import { Controller, InternalServerErrorException, NotFoundException, Query, StreamableFile } from '@nestjs/common';
import { ApiBearerAuth, ApiTags } from '@nestjs/swagger';
import config from 'config';
import { createReadStream } from 'fs';
import { isEmpty, trimStart } from 'lodash';
import { contentType } from 'mime-types';
import path from 'path';

import { DownloadFileInputModel } from '../models';
import { InfoResponse } from '../responses';
import { FileSystemUtility } from '../utilities';

@ApiBearerAuth()
@ApiTags('Download')
@Controller()
export class DownloadController {
  @InfoResponse('/download.file', StreamableFile)
  public async download(@Query() { attachment, name }: DownloadFileInputModel): Promise<StreamableFile> {
    const parts = trimStart(name, '/').split('/');
    if (isEmpty(parts) || parts.length !== 2) throw new InternalServerErrorException('Incorrect file path.');
    const filePath = path.resolve(config.get<string>(`paths.${parts[0]}`), parts[1]);
    if (!(await FileSystemUtility.exists(filePath))) throw new NotFoundException('File not found.');
    const disposition = attachment ? `attachment; filename="${attachment}"` : undefined;
    const type = contentType(path.extname(filePath)) || 'application/octet-stream';
    return new StreamableFile(createReadStream(filePath), { disposition, type });
  }
}
